<template>
  <div>
    <div class="text-right">
      <mdb-btn icon="save" color="primary" class="px-2 py-1" @click="onSave">저장</mdb-btn>
      <mdb-btn icon="times" color="danger" class="px-2 py-1" @click="onDelete">삭제</mdb-btn>
    </div>
    <training-overview-edit v-if="training" :training="training" />
  </div>
</template>
<script>
import {} from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Training from '@/models/Training'
import TrainingOverviewEdit from '@/components/training/TrainingOverviewEdit.vue'
export default {
  name: 'StaffOpenTrainingIntro',
  components: { TrainingOverviewEdit },
  data: () => ({
    TAG: 'StaffOpenTrainingIntro >>',
    training: {}
  }),
  computed: {
    ...mapState('auth', ['org'])
  },
  methods: {
    async load () {
      if (!this.org || !this.org._id) return
      const _id = this.$route.query.training
      if (_id) { // 수정
        this.training = await Training.get(_id)
        // if (!this.training.ncsTraining) {
        //   this.training.ncsTraining = {}
        // }
        // if (!this.training.teacher) {
        //   this.training.teacher = {}
        // }
      } else { // 새 훈련 생성
        this.training = Training.create(this.org)
      }
      if (!this.training.ncsTraining) {
        this.training.ncsTraining = { name: '' }
      }
    },
    async onSave () {
      if (!confirm('저장할까요?')) return
      if (!this.training.ncsTraining._id) {
        this.training.ncsTraining = undefined
      }
      this.training = await this.training.save()
      if (!this.training.ncsTraining) {
        this.training.ncsTraining = { name: '' }
      }
    },
    async onDelete () {
      if (!confirm('삭제할까요?')) return
      await this.training.delete()
      this.$router.push({ name: 'StaffOpenTrainingPage' })
    }
  },
  watch: {
    org: 'load'
  },
  created () { this.load() }
}
</script>
